import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { API, Chat, Info, Integrations } from '../assets';
import { map } from 'lodash';
import MenuLinkWithIcon from './MenuLinkWithIcon';

const resources = [
    {
        icon: Chat,
        title: "resourcesMenu.blog",
        subtitle: "resourcesMenu.blogDescription",
        href: "/blog"
    },
    // {
    //     icon: Info,
    //     title: "resourcesMenu.knowledgeBase",
    //     subtitle: "resourcesMenu.commonDescription",
    // },
    {
        icon: Integrations,
        title: "resourcesMenu.integrations",
        subtitle: "resourcesMenu.integrationsDescription",
    },
    {
        icon: API,
        title: "resourcesMenu.apiDocumentation",
        subtitle: "resourcesMenu.apiDocumentDescription",
        href: '/documentation'
    }
]

const ResourcesMenu = ({ ...props }) => {

    const { t } = useTranslation('public');

    return (
        <Box sx={{ paddingInlineStart: 4, paddingInlineEnd: 6, paddingBlock: 2, minWidth: '300px' }}>
            <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '130%', mb: 3 }}>
                {t("Resources")}
            </Typography>
            {
                map(
                    resources,
                    resource => <MenuLinkWithIcon link={resource} sx={{ marginBlock: 2 }} />
                )
            }
        </Box>
    );
}

export default ResourcesMenu;
